import PopUp from 'components/PopUp/PopUp';
import {Box, FormControl, FormHelperText, FormLabel, Stack, TextField} from '@mui/material';
import React, {ChangeEvent} from 'react';
import TurnstileWidget from 'components/TurnstileWidget/TurnstileWidget';
import {useSelector} from 'react-redux';
import {CaptchaStatuses, selectCaptchaStatus} from 'app/store/registration/registrationSlice';

type EmailPopupProps = {
  open: boolean;
  confirm: (email: string) => Promise<void>;
  cancel: () => void;
  pending?: boolean;
};

const EmailPopup = ({open, confirm, cancel, pending = false}: EmailPopupProps) => {
  const [userEmail, setUserEmail] = React.useState('');
  const [validEmail, setValidEmail] = React.useState(true);
  const captchaStatus = useSelector(selectCaptchaStatus);

  const handleConfirm = async () => {
    console.log('Email:', userEmail); // handle confirm
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (userEmail && emailRegex.test(userEmail)) {
      await confirm(userEmail); //send email in callback
      clearInputs();
      //await validateEmail(userEmail); -- Needs to be a callback
    } else {
      setValidEmail(false);
    }
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setUserEmail(event.target.value);
  };

  const clearInputs = () => {
    setUserEmail('');
    setValidEmail(true);
  };

  const submitForm = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    handleConfirm();
  };

  return (
    <PopUp
      title='Enter your email to register'
      onCancel={() => {
        cancel();
        clearInputs();
      }}
      onConfirm={() => handleConfirm()}
      open={open}
      confirmedDisabled={!userEmail || captchaStatus !== CaptchaStatuses.Solved || pending}
      confirmText='Submit'
      maxWidth='sm'
      width='520px'
    >
      <Box display='flex' justifyContent='center' alignItems='center' width='100%' pt='20px' marginBottom='-20px'>
        <Stack component='form' onSubmit={submitForm} spacing={0.5} width='100%' height='100%'>
          <FormControl>
            <FormLabel sx={{marginBottom: '5px'}}>Email</FormLabel>
            <TextField
              variant='outlined'
              size='small'
              placeholder='Enter your email'
              sx={{width: '480px', borderRadius: '6px'}}
              value={userEmail}
              onChange={handleChange}
            />
            <Box height={validEmail ? '10px' : '20px'}>
              {!validEmail && <FormHelperText>Invalid Email. Please enter a valid email</FormHelperText>}
            </Box>
          </FormControl>
          <Box width='100%' display='flex' justifyContent='center' alignItems='center' minHeight='70px'>
            <TurnstileWidget />
          </Box>
        </Stack>
      </Box>
    </PopUp>
  );
};

export default EmailPopup;
